import _map from "lodash/map";
import _get from "lodash/get";
import _find from "lodash/find";
import _deburr from "lodash/deburr";
import {
  ContactType,
  CustomerGender,
  CustomerSegment,
  CustomerStatus,
  CustomerType,
} from "./constants";

const contactsAdapter = (customer) => {
  const contacts = _get(customer, "contacts", []);

  const contactList = _get(customer, "portalUser.contactList", []);

  return _map(contacts, (contact) => {
    const portalUser = _find(
      contactList,
      (item) => item.clientId === contact.clientId
    );

    return {
      ...contact,
      contactStatus: CustomerStatus[contact.contactStatus],
      contactType: ContactType[_deburr(contact.contactType)],
      gender: _get(contact, "gender", ContactType.NOT_SUPPORTED),
      visualImpairment: _get(
        contact,
        "visualImpairment",
        ContactType.NOT_SUPPORTED
      ),
      portalUser,
    };
  });
};

export const customerAdapter = (customer) => ({
  ...customer,
  contacts: contactsAdapter(customer),
  customerSegment: CustomerSegment[customer.customerSegment],
  customerStatus: CustomerStatus[customer.customerStatus],
  customerType: CustomerType[customer.customerType],
  ebillingAccess: CustomerStatus[customer.ebillingAccess],
  gender: CustomerGender[customer.gender],
  isOnlineManager: CustomerStatus[customer.isOnlineManager],
  isSegmentOperator: CustomerStatus[customer.isSegmentOperator],
  receiveOfferByEmail: CustomerStatus[customer.receiveOfferByEmail],
  receiveOfferBySms: CustomerStatus[customer.receiveOfferBySms],
  visualImpairment: CustomerStatus[customer.visualImpairment],
});



// WEBPACK FOOTER //
// ./src/services/state/customer/adapter.js